const images = {
  logo: require('./img/videopeel-logo.png'),
  logoinner: require('./img/videopeel-logo.png'),
  user: require('./img/User.png'),
  splashuser: require('./img/user1.png'),
  embeddLogo: require('./img/embeddLogo.png'),
  whiteLogo: require('./img/videoPeel-white-logo.png'),
  appsumo: require('./img/appsumo.png'),
}
export default images;



// WEBPACK FOOTER //
// ./src/style/images.js